/**
 * Store: Back in stock drawer
 * -----------------------------------------------------------------------------
 * Handles back in stock drawer actions
 */

export default {
  namespaced: true,

  state: () => ({
    product: false,
    variant: false,
    config: {
      strings: {
        return: '',
        back: '',
      },
      location: {},
    },
  }),

  mutations: {

    /**
     * Set state property.
     */
    SET_CONFIG(state, config = {}) {
      state.config = {
        ...state.config,
        ...config || {},
      }
    },

    /**
     * Set state property.
     */
    SET_PRODUCT(state, product = false) {
      state.product = product
    },

    /**
     * Set state property.
     */
    SET_VARIANT(state, variant = false) {
      state.variant = variant
    },
  },

  actions: {

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setConfig({ commit }, config = {}) {
      commit('SET_CONFIG', config)
    },

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setBackInStockDrawerProduct({ commit }, product = false) {
      commit('SET_PRODUCT', product)
    },

    /**
      * Set variant data.
      * @param {Object} product - Variant object.
      */
    setBackInStockDrawerVariant({ commit }, variant = false) {
      commit('SET_VARIANT', variant)
    },
  },
}
